import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import store from './store'
import { ThemeProvider } from "@mui/material"
import sofoTheme from './theme/sofoTheme'

const rootElement = document.getElementById('root');

ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider theme={sofoTheme}>
      <App />
    </ThemeProvider>
  </Provider>,
  rootElement);


registerServiceWorker();

